const styles = theme => ({
  formSection: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  sectionTitle: {
    color: '#002E47',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '36px',
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: '#CBD0D7',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  input: {
    width: '100%',
    border: '1px solid #919EAB',
    borderRadius: 10,
    padding: '4px 12px',
    margin: 0,
    '& .MuiInputBase-root': {
      fontSize: 15,
      color: '#002E47',
      fontFamily: 'Inter',
    },
    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      display: 'none',
    },
  },
  submit: {
    alignSelf: 'flex-end',
  },
  deleteRow: {
    width: '100%',
    marginTop: 40,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    padding: 24,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  deleteTitle: {
    color: '#637381',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '36px',
  },
  invalid: {
    color: '#002E47',
    padding: '6px 10px',
    border: '1px solid rgba(145, 158, 171, 0.32)',
    borderRadius: 50,
    fontSize: 12,
    lineHeight: '18px',
    textDecoration: 'none',
    backgroundColor: '#FFFFFF',
  },
  valid: {
    color: '#29D25D',
    padding: '6px 10px',
    border: '1px solid #29D25D',
    borderRadius: 50,
    fontSize: 12,
    lineHeight: '18px',
    textDecoration: 'none',
    backgroundColor: 'rgba(41, 210, 93, 0.1)',
  },
  strengthMeter: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  loadingWrap: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 8,
  },
  dialogPaper: {
    width: 'min(520px, calc(100vw - 32px))',
    maxWidth: 520,
    borderRadius: 12,
    boxShadow: '0px 12px 48px 0px rgba(145, 158, 171, 0.48)',
    padding: 24,
  },
  deleteDialogPaper: {
    width: 520,
    maxWidth: 'calc(100vw - 32px)',
    minHeight: 191,
    height: 'auto',
    borderRadius: 16,
    opacity: 1,
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 12px 48px 0px #919EAB7A',
    padding: 0,
    overflow: 'hidden',
  },
  deleteDialogContent: {
    padding: '20px 20px 0 20px !important',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    overflow: 'hidden',
  },
  deleteDialogHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  deleteDialogIconWrap: {
    width: 36,
    height: 36,
    borderRadius: 9.6,
    backgroundColor: '#FF563029',
    padding: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  deleteDialogIconCircle: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: '#ED4245',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter',
    fontSize: 16,
    lineHeight: '16px',
    fontWeight: 600,
  },
  deleteDialogTitle: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: 0,
  },
  deleteDialogDescription: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '150%',
    letterSpacing: 0,
  },
  deleteDialogActions: {
    padding: '42px 20px 20px !important',
    marginTop: 0,
    minHeight: 'auto',
    justifyContent: 'flex-end',
    gap: 8,
    '& > :not(:first-child)': {
      marginLeft: '0 !important',
    },
  },
  deleteCancelButton: {
    color: '#26323D',
    width: 79,
    minWidth: 79,
    height: 36,
    opacity: 1,
    padding: '10px 16px',
    '& .MuiButton-label': {
      gap: 8,
    },
  },
  deleteConfirmButton: {
    minWidth: 76,
    width: 76,
    height: 36,
    borderRadius: 8,
    opacity: 1,
    backgroundColor: '#ED4245 !important',
  },
  dialogTitle: {
    color: '#002E47',
    fontFamily: 'Be Vietnam',
    fontStyle: 'normal',
    fontSize: 15,
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: 0,
    marginBottom: 8,
  },
  dialogDescription: {
    color: '#002E47',
    fontFamily: 'Be Vietnam',
    fontStyle: 'normal',
    fontSize: 15,
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: 0,
  },
  dialogActions: {
    marginTop: 8,
    padding: 0,
    justifyContent: 'flex-end',
    gap: 8,
  },
  div: {
    width: '100%',
  },
})

export default styles
